<template>
  <div v-if="abaVet !== null && abaVal !== null">
    <RF-Aba :class='"fin-con-ban--" + abaVal'
    :cpntAbas="Object.values(abaVet)"
    :cpntValue="abaVal"
    :cpntOnChange="finConBanOnChangeAba">
    <template slot="conteudo">
      <router-view :key="time"></router-view>
    </template>
    </RF-Aba>
  </div>
</template>

<style>
.fin-con-ban--importar > .tabs,
.fin-con-ban--importar > .conteudo-abas {
  width: 525px;
}
</style>

<script>
  export default {
    components: {
      'RF-Aba': () => import('@/components/rf-geral/aba/RF-Aba-2.vue')
    },
    data: function () {
      return {
        abaVet: null,
        abaVal: null,
      }
    },
    mounted: function () {
      this.finConBanCriarAbas()
    },
    methods: {
      finConBanCriarAbas: function () {
        // LIMPA AS ABAS ENCONTRADAS
        this.abaVet = {
          importar: { chave: 'importar', nome: 'Importar OFX', carregado: false, mostrar: false },
          conciliar: { chave: 'conciliar', nome: 'Conciliar Conta', carregado: false, mostrar: false  }
        }

        // VERIFICA A PAGINA QUE DEVE SETAR
        if (this.abaVal === null) {
          // INICIA A VARIAVEL
          var aba = ''

          // VERIFICA A ROTA QUE DEVE REDIRENCIONAR
          switch (this.$route.name) {
            case 'financeiro_con_bancaria_conciliar':
              aba = 'conciliar'
              break

            case 'financeiro_con_bancaria_importar':
            default:
              aba = 'importar'
              break
          }

          // SETA A ABA INICAL
          this.finConBanOnChangeAba(aba)
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      finConBanOnChangeAba: function (aba) {
        // INICIA A VARIAVEL DE ROTA
        var route = {}

        // VERIFICA A ROTA QUE DEVE REDIRENCIONAR
        switch (aba) {
          case 'importar':
            route = { name: 'financeiro_con_bancaria_importar', params: {} }
            break

          case 'conciliar':
            route = { name: 'financeiro_con_bancaria_conciliar', params: {} }
            break
        }

        // REDIRECIONA A TELA
        if (route.name !== this.$route.name) {
          this.$router.push(route)
        }

        // OCULTA TODAS AS ABAS
        for (var indexA in this.abaVet) {
          if (indexA !== aba) {
            this.abaVet[indexA].mostrar = false
          }
        }

        // SETA A ABA SELECIONADA
        this.abaVal = aba

        // SETA O STATUS DE CARREGAMENTO DA TELA
        this.abaVet[aba].carregado = true

        // SETA O STATUS DE CARREGAMENTO DA TELA
        this.abaVet[aba].mostrar = true

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
    }
  }
</script>
